import { post } from '../Services/http';
export const VAT_ONCHANGE = 'VAT_ONCHANGE';
export const updateVat = (value) => ({
    type: VAT_ONCHANGE,
    payload: {
        value
    },
}
);

export const updateAPIStatus = (url, model) => (dispatch) => 
        post(url, model)
        .then(response => response.json())
        .then((result) => dispatch(updateVat(result)))
        .catch((ex) => console.log(ex));


